import { useEffect, useState } from 'react'
import { marked } from 'marked'
import { Alert, Text } from '@mercai/clever'
import { useTranslation } from 'react-i18next'
// import { useLottie } from 'lottie-react'

import { formatNumber } from '@/helpers'

import styles from './ai-data.module.css'

import { AiDataProps } from './ai-data.type'
import { QuotationAIComplementAlertKeyProps } from '@/types'

export const AiData = ({ aiComplementData }: AiDataProps) => {
  const { t } = useTranslation('screenQuotationV2Show')
  const [html, setHtml] = useState('')

  //   const { View: RobotLottie } = useLottie({
  //     animationData: AiRobotLottie,
  //     loop: true,
  //     autoplay: true,
  //     hidden: false,
  //   })

  const getAlert = (alert: QuotationAIComplementAlertKeyProps[0]) => {
    if (alert?.type === 'insuficient_quantity_available') {
      return (
        <Alert
          variant="warning"
          title={t('quotationTabAiDataInsufficientQuantityAvailableTitle', {
            productCode: 'Unknown',
          })}
        >
          {t('quotationTabAiDataInsufficientQuantityAvailableDescription', {
            quantityAvailable: formatNumber(alert.quantityAvailable),
            quantityDesired: formatNumber(alert.quantityDesired),
          })}
        </Alert>
      )
    }

    if (alert?.type === 'minimum_purchase_quantity') {
      return (
        <Alert
          variant="warning"
          title={t('quotationTabAiDataMinimumPurchaseQuantityTitle', {
            productCode: 'Unknown',
          })}
        >
          {t('quotationTabAiDataMinimumPurchaseQuantityDescription', {
            minimumPurchaseQuantity: formatNumber(
              alert.minimumPurchaseQuantity,
            ),
            quantityDesired: formatNumber(alert.quantityDesired),
          })}
        </Alert>
      )
    }

    if (alert?.type === 'dynamic_margins') {
      return (
        <Alert variant="warning" title={`${alert?.description} Unknown`}>
          {alert?.explanation}
        </Alert>
      )
    }

    if (alert?.type === 'dynamic_cost') {
      return (
        <Alert variant="warning" title={alert.title}>
          <div>
            <p>{alert.description}</p>
            <p>{alert.explanation}</p>
          </div>
        </Alert>
      )
    }

    if (alert?.type === 'last_mile_cost') {
      return (
        <Alert variant="warning" title={alert?.title}>
          <div>
            <p>{alert?.description}</p>
            {alert?.explanation && <p>{alert?.explanation}</p>}
          </div>
        </Alert>
      )
    }

    return <Alert variant="warning">Unknown alert type</Alert>
  }

  useEffect(() => {
    const parseMarkdown = async () => {
      const explanation = aiComplementData?.smartFirstMile?.explanation || ''
      const parsedHtml = await marked(explanation)
      setHtml(parsedHtml)
    }

    parseMarkdown()
  }, [aiComplementData?.smartFirstMile?.explanation])

  return (
    <div className={styles.core}>
      {aiComplementData?.alerts?.map((alert, index) => (
        <div key={index}>{getAlert(alert)}</div>
      ))}

      {aiComplementData?.smartFirstMile?.explanation && (
        <div className={styles.explanation}>
          <img src="/images/ai-robot.gif" alt="ai-data" />
          <div className={styles['explanation-content']}>
            <Text variant="title-small" className={styles['explanation-texts']}>
              {t('quotationTabAiDataExplanationTitle')}
            </Text>

            <Text variant="text-small" className={styles['explanation-texts']}>
              <div
                className={styles['explanation-texts-content']}
                dangerouslySetInnerHTML={{ __html: html }}
              />
            </Text>
          </div>
        </div>
      )}

      {aiComplementData?.smartFirstMile?.explanationSteps?.map((step) => {
        if (!step?.title || !step?.explanation) return null

        return (
          <div className={styles['explanation-step']} key={step?.title}>
            <img
              src="/images/ai-robot.gif"
              alt="ai-data"
              className={styles['explanation-step-image']}
            />

            <div className={styles['explanation-step-content']}>
              <Text
                variant="title-small"
                className={styles['explanation-step-title']}
              >
                {step?.title}
              </Text>

              <Text
                variant="text-small"
                className={styles['explanation-step-explanation']}
              >
                {step?.explanation}
              </Text>
            </div>
          </div>
        )
      })}
    </div>
  )
}
